import React, { useState } from 'react';

type Props = {};

const ApiAccessPage = (props: Props) => {
  const [apiKey, setApiKey] = useState('C6954EF176EC419645BBE169DCAFFD9F');

  const regenerateKey = () => {
    const newKey = Math.random().toString(36).substring(2).toUpperCase() + Math.random().toString(36).substring(2).toUpperCase();
    setApiKey(newKey);
    alert('API Key Regenerated!');
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px',
    borderRadius: '0px',
    height: '80%',
  };

  const buttonStyle = {
    padding: '5px 20px',
    border: 'none',
    borderRadius: '0px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '10px',
    marginTop: '10px',
    display: 'block',
  };

  const titleStyle = {
    fontSize: '14px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  const descriptionStyle = {
    fontSize: '12px',
    marginBottom: '15px',
    display: 'flex',
    gap: '60px',
  };

  const apiKeyStyle = {
    fontSize: '12px',
    fontWeight: '400' as const,
    marginBottom: '10px',
  };

  const noteStyle = {
    fontSize: '10px',
    marginTop: '10px',
    color: 'gray',
  };

  const linkStyle = {
    color: '#1173B7',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '12px',
    marginRight:'10px'
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '80%', textAlign: 'left', margin: '0 20px' }}>
        <h2 style={titleStyle}>API Setup:</h2>

        <div style={{ display: 'flex' }}>
          <p style={descriptionStyle}>
            <span style={{ fontWeight: 'bold', fontSize: '10px' }}>API Key:</span> <br />

            <div>
              <span style={apiKeyStyle}>{apiKey}</span>
              <button onClick={regenerateKey} style={buttonStyle}>
                reGenerate Key
              </button>
            </div>
          </p>
        </div>



<div style={{display:'flex'}}>
<p style={descriptionStyle}>
          <span style={{ fontWeight: 'bold', fontSize:'10px' }}>API Documentation:</span>{' '}
        </p>
        <div style={{ marginLeft:'80px', fontSize:'12px'}}>
          <a
            href="#"
            style={linkStyle}
            onClick={() => window.open('https://api.example.com/docs', '_blank')}
          >
            Click here
          </a>{' '}
          to view the full API documentation [v2.5 - Beta Version] (opens in a new window)

          <p style={descriptionStyle}>
            Request body - under the "Request body" section in the API documentation you will find
            "Example Value" which shows the way the JSON should be scripted while under "Schema" you
            can see more detailed information regarding the values and meaning of each parameter.
          </p>
          <p style={noteStyle}>
            Please note: The API is fully operational - every action you take here will affect your
            campaigns, so please exercise caution when proceeding.
          </p>
        </div>
</div>
        

      </div>
    </div>
  );
};
export default ApiAccessPage;